import { Component, OnInit } from '@angular/core';
import { Router, Event, NavigationStart, NavigationEnd, NavigationError } from '@angular/router';

@Component({
  selector: 'app-common-layout',
  templateUrl: './common-layout.component.html',
  styleUrls: ['./common-layout.component.scss']
})
export class CommonLayoutComponent implements OnInit {

  showSidebar = true;
  showNavbar = true;
  showFooter = true;
  constructor(private router: Router) {}

  ngOnInit() {
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
    window.scrollTo(0, 0);
    });
  }

  isHidden() {
    const list = ['/home', ''],
      route = this.router.url;
    return (list.indexOf(route) > -1);
  }

}
